<!-- 队式赛裁判查询每一局的成绩 -->
<template>
<div class="container">
<!--   
  <div class="remain-time" v-if="isShowCountDown">剩余时间：{{countTime}}</div>
  <div class="remain-time" v-else="">{{errMsg}}</div> -->
  <div class="round-buttons">
    <el-button 
        v-for="item in totalRounds" 
        :key="item"
        :type="currentRound === item ? 'primary' : ''"
        @click="selectRound(item)"
        class="round-btn"
    >
        第{{ item }}轮
    </el-button>
    <div class="title">第{{currentRound}}轮 每把成绩({{second}}秒)</div>
  </div>
  <div v-if="dataList.length > 0">
    <!-- <div class="red mg-tb-20"> 红色分数为最终局</div> -->
    <div class="table-score" v-for="item in dataList">  
    <!-- 第一行 -->  
    <div class="table-tr">  
      <div class="table-td red size16">{{item.deskNo}}桌</div>
      <div v-for="childItem in  item.w" > 
        <div class="table-td">{{childItem.score}}</div>  
      </div>  
    </div>  
    <!-- 第二行 -->  
    <div class="table-tr">  
      <div class="table-td size16" >东西</div>
      <div v-for="childItem in item.w" >  
        <div :class="childItem.gamesNum === 111 ? 'redbg': 'table-td'">{{childItem.level}}</div>  
      </div>  
    </div>  
    <!-- 第三行 -->  
    <div class="table-tr ">  
      <div class="table-td size16 last-line">南北</div>
      <div class="last-line" v-for="childItem in item.n" >  
        <div :class="childItem.gamesNum === 111 ? 'redbg': 'table-td'">{{childItem.level}}</div>  
      </div>  
    </div>  
    <!-- 第四行   -->
    <!-- <div class="table-tr">  
      <div class="table-td size14">时间</div>
      <block v-for="childItem in item.w" >  
        <div class="table-td time-str">{{childItem.time}}</div>  
      </block>  
    </div>   -->
  </div>
  </div>
  <!-- <div v-else>
    <el-empty description="暂无成绩"></el-empty>
  </div> -->
</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
    data() {
        return {
            isShow: false,
            dataList:[],   
            errorShow: '',
            title: '',
            currentRound: 1,
            totalRounds: 4,
            deskNo: 1,
            scoreList: [],
            isShowCountDown: false,
            errMsg: '',
            second: 10,
            second50: 0,
            minute: 0,
            countdownTimer: null,
            gameCountdown: null,
            countTime: '',
            maxRound: 1,
            roundData: [],
            playerStatus: false
        }
    },
    computed:{
        // ...mapState(['round']),
     },
    created() {
        
    },
    mounted() {

    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.pubId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    let list = result.map(item=>{    
                        let typeArr =  this.$global.eventTypeList.filter(i=>i.label === item['类型'])
                        let type = typeArr[0].value              
                        return{
                            title: item['主题'],
                            amount: item['参赛人数'],
                            address: item['赛事地点'],
                            sponsor: item['赞助'],
                            maxNum: item['每局最大升级数'],
                            round:  item['比赛轮数'] + 1,
                            maxRound: item['轮数'],
                            type: type,
                        }
                    })
                    this.title = list[0].title
                    let maxRound = list[0].maxRound
                    let round = list[0].round <= maxRound ? list[0].round : maxRound
                    this.roundData = Array(maxRound).fill(0).map((_, i) => i + 1)
                    this.maxRound = maxRound
                    this.totalRounds = maxRound
                    this.currentRound = round            
                    if(round){
                        this.getGradeQuery()
                    }
                }else{
                    this.$message.error(res.Message)
                    this.stopCountdown()
                }
            })
        },
        getGradeQuery(){
            let params = {
                opcode: this.$code.AllScoreQuery,
                i_serial_mark: this.pubId,
                i_round: this.currentRound,
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                let result = res.Data.DataTable
                if(result.length > 0){
                    let scoreList = result.map(item=>{
                        // let timeStr = item['积分时间'] === 0 ? '': (item['积分时间']).toString()
                        // let time = ''
                        // if(timeStr!==''){
                        // if(timeStr.length>5){
                        //     let time1 = timeStr.slice(0,2)
                        //     let time2 = timeStr.slice(2,4)
                        //     time = time1+':'+time2
                        // }else{
                        //     let time1 = timeStr.slice(0,1)
                        //     let time2 = timeStr.slice(1,3)
                        //     time = time1+':'+time2
                        // }                 
                        // }                 
                        return{
                            deskNo: item['桌号'],
                            id: item['选手编号'],
                            username: item['选手名称'],
                            gamesNum: item['局数'],
                            seat: item['座位'],
                            round: item['轮数'],
                            score: item['成绩'],
                            level: item['升级'],
                            // time: time,
                        }
                    })   
                let obj = this.selectDeskNo(scoreList)
                // console.log('arr',obj)
                let list = obj.map(table => {  
                // 使用 reduce 方法来合并同一桌内具有相同 id 的用户成绩  
                let mergedUsers = table.users.reduce((acc, user) => {  
                    // 检查累加器（acc）中是否已经有这个 id 的用户  
                    if (!acc[user.id]) {  
                        // 如果没有，则初始化这个 id 的用户，并设置其 games 为空数组  
                        acc[user.id] = { games: [] };  
                        // 可能需要删除一些不需要的重复字段  
                        delete acc[user.id].deskNo; // 如果 deskNo 在这里不需要  
                    }  
                    // 将用户现有的游戏记录添加到 mergedUsers 中  
                    acc[user.id].games.push({ 
                        gamesNum: user.gamesNum, 
                        score: user.score,
                        level: user.level,
                        time: user.time,
                        seat:user.seat,
                        id: user.id })                 
                    return acc;  
                }, {});              
                // 将对象转换为数组，并添加桌号信息（如果需要）  
                let usersArray = Object.values(mergedUsers).map(user => { 
                    // 对每个用户的 games 数组进行排序  
                    user.games.sort((a, b) => a.gamesNum - b.gamesNum);
                    return{
                        ...user,  
                        deskNo: table.deskNo, // 添加桌号信息  
                    }
                });      
                return { deskNo: table.deskNo, users: usersArray }; // 返回包含桌号和用户的对象  
            });           
            // console.log(list);         
            let doubleArr = JSON.parse(JSON.stringify(list))   
            let doubleScore = this.mergeDoubleData(doubleArr)

            this.dataList = doubleScore
            // console.log('队式赛新数组',doubleScore)            
            }   
            }else{
                this.$message.error(res.Message)
            
            }
        })            
        },
        // 东西分数合并，南北分数合并
        mergeDoubleData(arr){
            const result = [];  
            arr.forEach(item => {  
                let currentW = [];  
                let currentN = [];    
                // 遍历对象的每个属性（即0, 1, 2, 3...）  
                    item.users.forEach(i => {  
                    let w =  i.games.filter(a=>a.seat === '东-西')  
                    let n =  i.games.filter(a=>a.seat === '南-北') 
                        // 如果w数组不为空，合并到currentW  
                        if (w && w.length > 0) {  
                            currentW = [...currentW, ...w];  
                        }  
                        // 如果n数组不为空，合并到currentN  
                        if (n && n.length > 0) {  
                            currentN = [...currentN, ...n];  
                        }  
                    });  
                    // 将合并后的w和n添加到结果数组中  
                    result.push({ w: currentW, n: currentN, deskNo: item.deskNo });  
                });  
            return result;  
        },
        selectDeskNo(arr){
            let result = []
            arr.forEach((item,index) => {
                if(!result.some(i => i.deskNo === item.deskNo )){
                    let users = arr.filter(user => user.deskNo === item.deskNo)         
                    result.push({
                        deskNo: item.deskNo,
                        users: users
                    })
                }
            });
            return result
        },
        selectRound(value){
            console.log(value)
            this.currentRound = value;
            if(value){
                this.getGradeQuery()
            }
        },
        // 10秒倒计时
        getTimeQuery(){
            clearInterval(this.countdownTimer)
            this.countdownTimer = setInterval(()=>{
                if(this.second > 0){
                    this.second--
                }else{
                    this.second = 10
                    this.getGradeQuery()
                }      
            },1000)
        },
        // 比赛倒计时查询
        gameTimeQuery(){
            let params = {
                opcode: this.$code.TimerQuery,
                i_serial_mark: this.pubId,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let list = res.Data.DataTable
                    let result = list.map(i=>{
                        return{
                            t: i['倒计时'],
                            status: i['状态'],
                        }
                    })
                    let arr = result[0]
                    if(arr.status === '开始'){
                    let arr2 = arr.t.split(':')                      
                        if(Number(arr2[0]) > 0){
                            this.minute =  Number(arr2[0])
                            this.second50 =  Number(arr2[1])
                        }else{
                            this.minute =  0,
                            this.second50 = Number(arr2[1])
                        }  
                        this.countDownFn()  
                    }else if(arr.status === '暂停'){
                        // 暂停状态 
                        this.countTime =  result[0].t
                        clearInterval(this.gameCountdown)
                    }else if(arr.status === '结束'){
                        // 结束状态                     
                        this.countTime= '00:00'                   
                        clearInterval(this.gameCountdown)
                    }                         
                    this.isShowCountDown = true                    
                    this.playerStatus = true
                }else{
                    this.isShowCountDown = false
                    this.errMsg = '倒计时未开始！'
                    this.playerStatus = false
                    
                    clearInterval(this.gameCountdown)
                }
            })
        },
        // 倒计时方法
        countDownFn(){
            // console.log(this.minute,this.second50)
            let remainingTime = this.minute * 60 + this.second50
            this.gameCountdown = setInterval(()=>{
                var minutes = Math.floor(remainingTime / 60);
                var seconds = remainingTime % 60;
                // 在页面上更新倒计时显示
                let displayTime = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds)

                this.countTime = displayTime
                if(remainingTime > 0){            
                    this.playStatus = true
                    remainingTime--;
                }else{
                    // 当倒计时结束时清除定时器
                    clearInterval(this.gameCountdown)
                }
            },1000)
        },
        stopCountdown(){
            clearInterval(this.countdownTimer)
            clearInterval(this.gameCountdown)
            this.countdownTimer = null
            this.gameCountdown = null
        }
    },
    beforeDestroy() {
        this.stopCountdown()  
    },
    destroyed(){
        this.stopCountdown()  
    },
}
</script>
<style lang='scss' scoped>
.round-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.action-buttons {
    display: flex;
    gap: 10px;
}
.title{
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  padding: 10px 0;
}
.table-score {  
  display: flex;  
  flex-direction: column;  
  background-color: #fff;
//   border: 1px solid #ccc;  
//   overflow: scroll;
  margin-bottom: 10px;
//   width: 100%;
  border-collapse: collapse; /* 合并边框，消除间隙 */
  table-layout: auto; /* 自动调整列宽 */
}    
.table-tr {  
  display: flex;  
}  
.table-td {  
//   flex: 1; /* 让单元格宽度平分 */  
  text-align: center; /* 文本居中 */  
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
//   border-bottom: 1px solid #ccc; /* 单元格之间分隔线 */  
  padding: 10px 20px;
  width: 50px;
  font-size: 22px;
  font-weight: bold;
}
.time-str{
  font-size: 14px;
}
.mg-tb-20{
  margin: 10px;
}
.redbg{
  background-color: green;
//   flex: 1; /* 让单元格宽度平分 */  
  text-align: center; /* 文本居中 */  
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc; /* 单元格之间分隔线 */  
  color: #fff;
  padding: 10px 20px;
  width: 50px;
    font-size: 22px;
  font-weight: bold;
}
.remain-time{
  margin: 20px 0;
  color: red;
  font-size: 14px;
}
.last-line{
    border-bottom: 1px solid #ccc;
}
</style>


// WEBPACK FOOTER //
// src/views/team/components/teamScoreQuery.vue